<template>
    <div class="cruise-stappen border2 stap1 width100 marginbottom15">
        <div class="stap-header lichtblauwbg width100 ">
            <div class="fontsize14 bold midblauw padding10 uppercase">
                Stap {{ this.currentStep }}: Samenstelling Reis
            </div>
        </div>

        <div class="stap-content" style="padding:10px;">
            <div
                class="regel borderbottom paddingtop5 paddingbottom5 lineheight32 floatleft reisstap"
            >
                <div
                    class="label width20 floatleft bold uppercase paddingleft10"
                >
                    Aantal hutten:
                </div>
                <div class="aantal_hutten">
                    <div class="widthauto  marginright20 floatleft">
                        <div class="select-drop floatleft">
                            <select
                                v-model="cabinCount"
                                class="selectpaddingsmall marginright5 autowidth floatleft"
                                name="aantal_hutten"
                                id="select_aantal_hutten"
                            >
                                <option
                                    v-for="index in cabinMaxPax"
                                    :key="'CabinCountSelect' + index"
                                    :value="index"
                                    >{{ index }}</option
                                >
                            </select>
                        </div>
                    </div>
                </div>
            </div>

            <div
                v-for="index in cabinCount"
                :key="'cabinSetupComponent' + index"
                class="reisstap samenstelling_hut"
            >
                <cabin-setup-item :index="index - 1" />
            </div>
            <div class="clear"></div>

            <Verzorging />
            <div class="clear"></div>

            <Fooien />
            <div class="clear"></div>

            <div
                v-if="cabinHasNonAdult && showKinderKorting"
                class="floatleft kindWarning padding10 borderbottom regelpadding lineheight32  kindleeftijdregel"
            >
                <div class="floatleft" style="clear: both;">
                    <div
                        class="padding10"
                        style="line-height: 18px;color: #FF0201!important;"
                    >
                        <font-awesome-icon
                            icon="times"
                            @click="toggleKinderKorting()"
                            style="float:right;"
                        />
                        <span class="font14"><b>Kinderkorting :-)</b></span
                        ><br />
                        Bij het tonen van de kinderprijzen is er mogelijk nog
                        geen
                        <span><b>kinderkorting</b></span> verwerkt. Zodoende is
                        de prijs aan de rechterkant een indicatie. Onze cruise
                        specialisten gaan graag voor je aan de slag om de meest
                        voordelige totaalprijs te verzorgen. Vraag hiervoor een
                        vrijblijvende offerte aan of bel ons op
                        <a
                            href="tel:0107200500"
                            style="font-weight:normal;color: #FF0201!important;text-decoration:underline;"
                            >010-7200500</a
                        >.
                    </div>
                </div>
            </div>
            <div
                v-if="cabinHasMaxPassenger"
                class="floatleft kindWarning padding10 borderbottom regelpadding lineheight32  kindleeftijdregel"
            >
                <div class="floatleft" style="clear: both;">
                    <div
                        class="padding10"
                        style="line-height: 18px;color: #FF0201!important;"
                    >
                        <span class="font14"
                            ><b>Aantal personen in de hut</b></span
                        ><br />
                        Het opgegeven aantal personen in een hut is op aanvraag.
                        Wij zullen de meest voordelige samenstelling in de
                        offerte aanvraag berekenen.
                    </div>
                </div>
            </div>
            <div class="clear"></div>
        </div>
    </div>
</template>

<script>
import CabinSetupItem from './CabinSetupItem'
import Verzorging from './Verzorging'
import Fooien from './Fooien'

export default {
    name: 'CabinSetup',
    components: {
        CabinSetupItem,
        Verzorging,
        Fooien,
    },
    data: function() {
        return {
            showKinderKorting: true,
        }
    },
    props: {
        currentStep: Number,
    },

    computed: {
        cabinCount: {
            get: function() {
                return this.$store.state.cabinCount
            },
            set: function(newValue) {
                //@todo convert to store commit
                this.$store.state.cabinCount = newValue
            },
        },
        cabinMaxPax: function() {
            return this.$store.state.cabinMaxPax
        },
        cabinSetup: function() {
            return this.$store.state.cabinSetup
        },
        cabinHasNonAdult: function() {
            let hasNonAdult = false

            this.cabinSetup.forEach(function(cabin) {
                if (cabin.kinderen > 0 || cabin.jeugd > 0 || cabin.baby > 0) {
                    hasNonAdult = true
                }
            })

            return hasNonAdult
        },
        cabinHasMaxPassenger: function() {
            let hasMaxPassenger = false

            this.cabinSetup.forEach(function(cabin) {
                let totalCabin =
                    cabin.volwassenen +
                    cabin.kinderen +
                    cabin.jeugd +
                    cabin.baby
                if (totalCabin > 4) {
                    hasMaxPassenger = true
                }
            })

            return hasMaxPassenger
        },
    },
    methods: {
        toggleKinderKorting: function() {
            this.showKinderKorting = !this.showKinderKorting
        },
    },
}
</script>

<style scoped></style>
